export default __webpack_public_path__ + "static/media/Shield of Yag.0e8cb0fa.jpg";